import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { apiURI, authErrorRedirect } from "../common";

export function DeleteUserConfirmation({
  email,
  openConfirmationDialog,
  handleConfirmationClose,
}) {
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  const [errors, setErrors] = useState();
  const [confirmEmail, setConfirmEmail] = useState();

  const handleChange = (event) => {
    setConfirmEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const deleteUser = {
      email,
    };
    if (confirmEmail === email) {
      axios
        .post(`${apiURI}/auth/deleteUser`, deleteUser)
        .then(() => {
          history("/users");
        })
        .catch((response) => {
          console.log(
            "error in axios login call react: ",
            response.response.data
          );
          setErrors({});
          setErrors(response.response.data);

          authErrorRedirect(response.response.data, history);
        });
    } else {
      setErrors({ email: "Incorrect email entered" });
    }

    // eslint-disable-next-line no-console
  };
  return (
    <Dialog open={openConfirmationDialog} onClose={handleConfirmationClose}>
      <DialogTitle>Delete user</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`To delete this user, please re-enter their email address: ${email} below for confirmation.`}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="email"
          label="Email Address"
          type="email"
          fullWidth
          variant="standard"
          onChange={handleChange}
          error={errors?.email && true}
          helperText={errors?.email !== "" ? errors?.email : " "}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirmationClose}>Cancel</Button>
        <Button onClick={handleSubmit} color="error">
          {!loading ? "Delete" : "Deleting"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
